import Vue from "vue";
import { getDurationFormat } from "@/tools/dateUtils";

export const capitalize = (value) => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const lowercase = (value) => {
  if (!value) return "";
  return value.toLowerCase();
};

export const displayDuration = (value) => {
  if (value) {
    return getDurationFormat(value);
  }

  return "-";
};

Vue.filter("capitalize", (value) => capitalize(value));
Vue.filter("lowercase", (value) => lowercase(value));
Vue.filter("displayDuration", (value) => displayDuration(value));
